@if (visible) {
<div class="fixed inset-0 flex items-center justify-center p-6" [style.z-index]="zIndex" (click)="onWrapperClick()" (keydown.escape)="onWrapperEscape()">
  <div class="absolute inset-0 bg-[rgba(39,43,52,0.24)]" (click)="onBackdropClick()"></div>

  <div [style.width]="width"
    class="relative z-10 bg-light rounded-3xl shadow-custom max-w-full border border-[#9AA8BC20] max-h-[90vh] flex flex-col min-h-0"
    [ngClass]="{ 'overflow-visible': overflowVisible, 'overflow-hidden': !overflowVisible }"
    [class]="customClass" (click)="stopPropagation($event)" (keydown.escape)="onWrapperEscape()" role="dialog" aria-modal="true">

    <!-- Header fijo -->
    @if (showHeader) {
    <div class="flex items-start justify-between w-full px-4 xs:px-6 pt-4 xs:pt-6 pb-4 border-b border-[#E5E7EB] flex-shrink-0"
      [ngClass]="{ 'bg-light rounded-t-3xl': overflowVisible }">
      <h2 class="font-poppins font-semibold text-[22px] leading-[24px] text-text-primary m-0">{{ title }}</h2>
      <button class="text-[10px] text-text-primary" (click)="close()">
        <i class="fi fi-ss-cross text-text-primary"></i>
      </button>
    </div>
    }

    <!-- Cuerpo scrollable -->
    <div class="flex-1 min-h-0 px-4 xs:px-6 py-4 pt-0"
      [ngClass]="overflowVisible ? 'overflow-visible' : 'overflow-y-auto overflow-x-hidden'">
      <div #modalContent></div>
    </div>

    <!-- Pie fijo -->
    @if (showFooter) {
    <div class="px-4 xs:px-6 py-4 border-t border-[#E5E7EB] flex-shrink-0 bg-light"
      [ngClass]="{ 'rounded-b-3xl': overflowVisible }">
      @if (nodeStatus().type !== 'idle') {
      <div class="mb-3">
        @if (nodeStatus().type === 'ok') {
        <div class="flex items-center gap-2 px-3 py-2 rounded-xl bg-[#E6F7EE] border border-[#4CAF7220]">
          <i class="fi fi-sr-check-circle text-[#2E7D32] text-base leading-none flex items-center"></i>
          <span class="text-[13px] font-medium text-[#2E7D32]">Nodo listo para guardar</span>
        </div>
        }
        @if (nodeStatus().type === 'error') {
        <div class="rounded-xl bg-[#FEF0F0] border border-[#F4433620]">
          <div class="flex items-center justify-between px-3 py-2">
            <div class="flex items-center gap-2">
              <i class="fi fi-sr-ban text-negative text-base leading-none flex items-center"></i>
              <span class="text-[13px] font-medium text-negative">
                {{ nodeStatus().errorCount }} {{ nodeStatus().errorCount === 1 ? 'error debe resolverse' : 'errores deben resolverse' }} antes de guardar
              </span>
            </div>
            <button
              class="text-[12px] font-semibold text-negative underline underline-offset-2 hover:opacity-70 transition-opacity"
              type="button"
              (click)="toggleMessages()">
              {{ (nodeStatus().messages?.length ?? 0) > 0 ? (messagesExpanded() ? 'Ocultar errores' : 'Ver errores') : 'Ver errores' }}
            </button>
          </div>
          @if (messagesExpanded() && (nodeStatus().messages?.length ?? 0) > 0) {
          <ul class="px-3 pb-2 pt-0 m-0 list-none flex flex-col gap-1">
            @for (msg of nodeStatus().messages; track $index) {
            <li class="flex items-start gap-2 text-[12px] text-negative">
              <i class="fi fi-sr-bullet text-[8px] leading-none mt-[6px]"></i>
              <button type="button" class="text-left hover:underline" (click)="scrollToMessage($index)">{{ msg.text }}</button>
            </li>
            }
          </ul>
          }
        </div>
        }
        @if (nodeStatus().type === 'warning') {
        <div class="rounded-xl bg-[#FFF8E1] border border-[#FFC10720]">
          <div class="flex items-center justify-between px-3 py-2">
            <div class="flex items-center gap-2">
              <i class="fi fi-sr-triangle-warning text-[#F57F17] text-base leading-none flex items-center"></i>
              <span class="text-[13px] font-medium text-[#F57F17]">
                {{ nodeStatus().warningCount }} {{ nodeStatus().warningCount === 1 ? 'advertencia' : 'advertencias' }} — se puede guardar
              </span>
            </div>
            <button
              class="text-[12px] font-semibold text-[#F57F17] underline underline-offset-2 hover:opacity-70 transition-opacity"
              type="button"
              (click)="toggleMessages()">
              {{ (nodeStatus().messages?.length ?? 0) > 0 ? (messagesExpanded() ? 'Ocultar advertencias' : 'Ver advertencias') : 'Ver advertencias' }}
            </button>
          </div>
          @if (messagesExpanded() && (nodeStatus().messages?.length ?? 0) > 0) {
          <ul class="px-3 pb-2 pt-0 m-0 list-none flex flex-col gap-1">
            @for (msg of nodeStatus().messages; track $index) {
            <li class="flex items-start gap-2 text-[12px] text-[#F57F17]">
              <i class="fi fi-sr-bullet text-[8px] leading-none mt-[6px]"></i>
              <button type="button" class="text-left hover:underline" (click)="scrollToMessage($index)">{{ msg.text }}</button>
            </li>
            }
          </ul>
          }
        </div>
        }
      </div>
      }
      <div class="flex justify-end gap-4 h-12">
        @if (showCancelButton) {
        <app-buttons [type]="cancelButtonType" [text]="cancelButtonText" size="medium" typeButton="button"
          (buttonClick)="close()">
        </app-buttons>
        }
        @if (showConfirmButton) {
        <div class="relative group" [title]="confirmButtonDisabled ? 'Resuelve los errores antes de guardar' : ''">
          <div [class.btn-shake]="confirmButtonShake()">
            <app-buttons [text]="confirmButtonText" [type]="confirmButtonType" size="medium" typeButton="button"
              [disabled]="confirmButtonDisabled"
              (buttonClick)="confirm()">
            </app-buttons>
          </div>
          @if (confirmButtonDisabled && nodeStatus().type === 'error') {
          <div class="absolute bottom-full right-0 mb-2 px-3 py-1.5 bg-text-primary text-white text-[12px] rounded-lg whitespace-nowrap pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-10 shadow-md">
            Resuelve los errores antes de guardar
            <div class="absolute top-full right-4 border-4 border-transparent border-t-text-primary"></div>
          </div>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
}
